module.exports = __webpack_public_path__ + "static/media/logo-yogiyo.49a68147.png";